import { isAxiosError } from "axios";
import Vue from 'vue'

export function successNotificationWrapper(message:string, description:string): void {
  Vue.prototype.$notification.success({
    message,
    description,
    placement: 'bottomRight',
    duration: 2.5,
    class: 'successNotification',
  })
}

export function warningNotificationWrapper(message: string, description: string): void {
  Vue.prototype.$notification.success({
    message,
    description,
    placement: 'bottomRight',
    duration: 2.5,
    class: 'warningNotification',
  })
}

export function errorNotificationWrapper(status: string, error: any): void {
  let message = error

  if (error) {
    if (isAxiosError(error)) {
      const response = error?.response

      if (response) {
        status = response.status.toString()

        if (response?.data?.message) {
          message = response.data.message
        }
      } else {
        message = error.message
      }
    } else if (error instanceof Error) {
      message = error.message
    } else {
      message = error
    }
  }

  console.error(status, message)

  Vue.prototype.$notification.error({
    message: status ? status : "Error",
    description: message ?? '',
    placement: 'bottomRight',
    duration: 2.5,
    class: 'errorNotification',
  })
}
